var map = {
	"./ar/skills.json": 8500,
	"./de/skills.json": 5812,
	"./en/skills.json": 9097,
	"./es/skills.json": 9714,
	"./fr/skills.json": 5943,
	"./pt/skills.json": 1785,
	"./ru/skills.json": 2970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2624;